/**
 * 목록 행의 분류 칩. 게시판 행(BoardItem)과 FAQ 행(FaqAccordionItem) 공용.
 * 색은 따로 붙인다 — 보통은 CATEGORY_CHIP_NEUTRAL, 이벤트 상태는 EVENT_STATUS_CLASS.
 */
export const CATEGORY_CHIP =
  'inline-flex min-w-[64px] shrink-0 items-center justify-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold';

export const CATEGORY_CHIP_NEUTRAL =
  'bg-black/[0.04] text-neutral-950/55 dark:bg-white/10 dark:text-white/55';
